import { THEME, ACTION_BUTTON } from "../config/siteConfig";

// Publishes the values from config/siteConfig.ts THEME as CSS variables used by App.css and the layout components
export const applyTheme = () => {
  const vars = {
    "--hdr-bg": THEME.HEADER_BG,
    "--hdr-text": THEME.HEADER_TEXT,
    "--menu-bg": THEME.MENU_BG,
    "--menu-text": THEME.MENU_TEXT,
    "--menu-active-bg": THEME.MENU_ACTIVE_BG,
    "--menu-active-text": THEME.MENU_ACTIVE_TEXT,
    "--menu-hover-bg": THEME.MENU_HOVER_BG,
    "--menu-hover-text": THEME.MENU_HOVER_TEXT,
    "--btn-bg": THEME.BUTTON_BG,
    "--btn-text": THEME.BUTTON_TEXT,
    "--btn-hover-bg": THEME.BUTTON_HOVER_BG,
    "--tab-active-bg": THEME.TAB_ACTIVE_BG,
    "--tab-active-text": THEME.TAB_ACTIVE_TEXT,
    "--tab-text": THEME.TAB_TEXT,
    "--th-bg": THEME.TABLE_HEADER_BG,
    "--th-text": THEME.TABLE_HEADER_TEXT,
    "--page-heading": THEME.PAGE_HEADING_TEXT,
    "--page-active-bg": THEME.PAGINATION_ACTIVE_BG,
    "--page-active-text": THEME.PAGINATION_ACTIVE_TEXT,
    "--btn2-bg": THEME.SECONDARY_BUTTON_BG,
    "--btn2-text": THEME.SECONDARY_BUTTON_TEXT,
    "--btn2-border": THEME.SECONDARY_BUTTON_BORDER,
    "--font-family": THEME.FONT_FAMILY,
  };
  ["view", "edit", "delete", "star"].forEach((k) => {
    vars["--act-" + k + "-bg"] = ACTION_BUTTON[k].BG;
    vars["--act-" + k + "-text"] = ACTION_BUTTON[k].TEXT;
  });
  vars["--act-size"] = ACTION_BUTTON.SIZE + "px";
  vars["--act-icon-size"] = ACTION_BUTTON.ICON_SIZE + "px";
  vars["--act-radius"] = ACTION_BUTTON.RADIUS + "px";
  const root = document.documentElement;
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
};
